import { environment } from '../environments/environment';

export const appConfig = {
  clientAppCode: 'visionamosCashier',
  mobile: false,
  signatureKey: 'dmlzaW9uYW1vc0Nhc2hpZXJLZXk=',
  apiRootPath: '/ws-cashier/',
  applicationName: 'Red Coopcentral',
  companyName: 'Red Coopcentral',
  deviceVerification: true,
  devicePreffix: 'VklTQ0FTSElFUg',
  verificationFrequency: 30000,
  sessionTimeout: 1800000, // 30 minutos
  warningDuration: 30000, // 30 segundos
  assetsBase: 'assets/default',
  liveConnection: false,
  logoutPath: '',
  privatePolicy: 'https://visionamos.com',
  googleApiKey: 'AIzaSyB9ARkqTDRoIK_1H4EIO8rUCyMeLtWAyG8',
  ...environment.appConfig,
};
